import { Fragment, ReactNode } from "react";
import backgroundImage from "../../images/pedagogique.jpg";

import { Button } from "../ui/button";
import { useNavigate } from "react-router-dom";

type Props = {
  children?: ReactNode;
};

const HomeCallToAction = (props: Props) => {
  const navigate = useNavigate();
  return (
    <Fragment>
      <div
        className="relative flex items-center justify-center h-full p-4 md:p-40"
        style={{
          zIndex: 0,
        }}
      >
        <div
          className="absolute inset-0 bg-cover "
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${backgroundImage})`,
            backgroundSize: "100% 100%",
            zIndex: -1,
          }}
        ></div>
        <div className="container">
          <div className="text-center">
            <div className="text-3xl font-bold text-white ">
              Découvrez notre Espace Pédagogique
            </div>
            <p className="text-white">
              Des visites éducatives sur le cycle de l'eau pour les classes du
              CP au CM2
            </p>
            <div className="mt-10">
              <Button
                className="w-56 text-white"
                onClick={() => navigate("/espace-pédagogique")}
              >
                En savoir plus
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default HomeCallToAction;
